<app-bookupp-header></app-bookupp-header>

<br />
<section id="faq" class="faq section-bg">
    <div class="container aos-init aos-animate" data-aos="fade-up">
        <div class="section-title">
            <h1 class="text-primary text-center">More info coming soon</h1>
            <br />
        </div>
        <br />
    </div>
</section>

<app-bookupp-footer></app-bookupp-footer>
